import Vue from 'vue';

// local state
const getDefaultState = () => {
	return {
		value: {
			component: '',
			isLoaded: false,
			closeModal: false,
			openModal: false,
			isLarge: false,

			callRef: false,
			withPayload: false,
			Payload: {},
		}
	}
};

const state = getDefaultState()

const getters = {

};

const mutations = {
	updatemodalSettings (state, value) {
	    state.value = value
	},
	setComponent (state, key) {
		state.value.isLoaded = false;
		state.value.component = key;
  	},
	isLarge (state, key) {
		state.value.isLarge = key;
  	},
	openModal (state) {
		state.value.openModal = false;
		state.value.openModal = true;
  	},
	closeModal (state) {
		state.value.closeModal = false;
		state.value.closeModal = true;
  	},
	callRef (state, payload = null) {
		if(payload != null) {
			state.value.Payload = payload;
			state.value.withPayload = true;
		}
		state.value.callRef = true;
	}
};

const actions = {
	setComponent ({ commit }, key) {
		commit('setComponent', key)
	},
	isLarge ({ commit }, key) {
		commit('isLarge', key)
	},
	open ({ commit }) {
		commit('openModal')
	},
	close ({commit}) {
		commit('closeModal')
	},
	resetState ({ commit }) {
		commit('resetState')
	},
	callRef ({ commit }, payload = null) {
		commit('callRef', payload)
	},

};

export default {
  	namespaced: true,
  	state,
  	getters,
  	actions,
  	mutations,
};